/**
 * Top brands per division for Executive Focus Note auto-selection.
 *
 * When a user generates an Executive Focus Note with only Division selected
 * (no manual brand filter), these brands are automatically included to focus
 * the analysis on the most important products for that division.
 *
 * Format: { DIVISION_NAME: [brand1, brand2, ...] }
 * Division names must match the values returned by the filter API (case-sensitive).
 */

const DIVISION_TOP_BRANDS = {
  PHARMA: ["OROFER-XT TAB", "PAUSE", "DYDROFEM"],
  "PHARMA NXT": ["ASOMEX", "PROXYM", "FERIUM XT", "OROFER XT + TONIC"],
  XENNEX: ["OROFER FCM", "GALACT"],
  IVA: ["MATERNA", "EMPROGEST", "CISCURE"],
  "EMCURE CV": ["ELAXIM", "CARDACE", "ROSUVAS EZ"],
  "EMCURE CV NXT": ["ELAXIM", "CLEXANE", "ROSUVAS EZ"],
  NEPAL: ["OROFER XT", "PAUSE", "ASOMEX", "METPURE"],
  NUCRON: ["METPURE", "TEMSAN", "EMSITA"],
  ORION: ["VYLDA", "NUMLO", "AMARYL"],
  LIFESTYLE: ["EFNOCAR", "BEVON", "KIMET XL"],
  Konker: ["INBEC", "SPEGRA", "TWINAQT", "VIROPIL"],
  REVIVA: ["MIRCERA", "CELLCEPT"],
  RENOVA: ["VINTOR", "ENCICARB 500", "VINGRAF", "MOFILET"],
  ONCOCARE: ["ENCICARB 1K", "SOMALINX", "EMBREMMA"],
  IMPETUS: ["ACEGABA", "GALOP", "ARMOD", "STROCOZ"],
  CONSINA: ["HAMSYL", "EMTREO", "VINTOR"],
  VAGUS: ["TENECTASE"],
};

/**
 * Returns the default top brands for a given division.
 * @param {string} division
 * @returns {string[]} Array of brand names, or empty array if no defaults configured.
 */
export function getTopBrandsForDivision(division) {
  if (!division) return [];
  return DIVISION_TOP_BRANDS[division] || DIVISION_TOP_BRANDS[division.toUpperCase()] || [];
}

export default DIVISION_TOP_BRANDS;
